import React from "react";
import { Col, Row } from "react-bootstrap";
import { SearchBars, Tabbles } from "../../../components";
import { PiBinoculars } from "react-icons/pi";
import { useTranslation } from "react-i18next";

const ClinicFinances = () => {
    const { t } = useTranslation();
    return (
        <Row>
            <Col md={12}>
                <SearchBars.SearchBar
                    className="search-bar"
                    showDate={true}
                    showSelect1={true}
                    showSelect2={true}
                    datepickermd={3}
                    selectColmd1={3}
                    selectColmd2={2}
                    searchColmd={2}
                    buttonColmd={2}
                    datepickerlg={3}
                    selectCollg1={3}
                    selectCollg2={3}
                    searchCollg={2}
                    buttonCollg={1}
                    searchGrpClassName="form-group1"
                    select1Classname="select3"
                    select2Classname="select3"
                    searchPlaceholder={t("Search")}
                    select1Placeholder={t("location")}
                    select2Placeholder={t("Clinic")}
                    cDateRangePlaceholder={t("enter") + " " + t("date")}
                    cDateRangeClassname="custom-date-range-picker"
                    buttonClassname="btn-solid-Aqua_Teal"
                    buttonChildren={<PiBinoculars className="bionCularIcon" />}
                />
            </Col>
            <Col md={12} className="table-col">
                <Tabbles.TableBlk />
            </Col>
        </Row>
    );
};

export default ClinicFinances;
